import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Card,
  CardContent,
  CardActionArea,
  Typography,
  CircularProgress,
} from "@mui/material";

import Page from "./Page";
import useData from "../../hooks/useData";

const InventoryClientSelector = () => {
  const navigate = useNavigate();
  const { getFromServer, sortByFields } = useData();
  const [inventoryProjects, setInventoryProjects] = useState([]);
  const [clientsById, setClientsById] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadInventoryProjects();
  }, []);

  const loadInventoryProjects = async () => {
    setLoading(true);

    const projects = await getFromServer({
      entityName: "Project",
      filter: { isActive: true, isInventoryEnabled: true },
    });

    const clients = await getFromServer({ entityName: "Client" });

    const clientMap = {};
    if (Array.isArray(clients)) {
      for (const client of clients) {
        if (client?.id) clientMap[client.id] = client;
      }
    }
    setClientsById(clientMap);

    const filtered = Array.isArray(projects)
      ? sortByFields(projects, ["name"])
      : [];

    setInventoryProjects(filtered);

    // If only one inventory-enabled project, navigate directly
    if (filtered.length === 1) {
      navigate(`/inventory/${filtered[0].id}`);
    }

    setLoading(false);
  };

  const handleProjectSelect = (projectId) => {
    navigate(`/inventory/${projectId}`);
  };

  return (
    <Page
      pageName="inventory-client-selector"
      includeToolbar={false}
    >
      <Box sx={{ p: 3 }}>
        {loading ? (
          <Box sx={{ display: "flex", justifyContent: "center", p: 5 }}>
            <CircularProgress />
          </Box>
        ) : inventoryProjects.length === 0 ? (
          <Typography
            variant="h6"
            sx={{ textAlign: "center", p: 5 }}
          >
            No inventory-enabled projects found
          </Typography>
        ) : (
          <>
            <Typography
              variant="h5"
              sx={{ mb: 3 }}
            >
              Select Project
            </Typography>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
              {inventoryProjects.map((project) => (
                <Card key={project.id}>
                  <CardActionArea
                    onClick={() => handleProjectSelect(project.id)}
                  >
                    <CardContent>
                      <Typography variant="h6">{project.name}</Typography>
                      {!!clientsById[project.clientId]?.name && (
                        <Typography
                          variant="body2"
                          color="text.secondary"
                        >
                          {clientsById[project.clientId].name}
                        </Typography>
                      )}
                    </CardContent>
                  </CardActionArea>
                </Card>
              ))}
            </Box>
          </>
        )}
      </Box>
    </Page>
  );
};

export default InventoryClientSelector;
